<template>
  <div>
    <ul v-if="enableLink" class="label-area">
      <li v-if="area">
        <nuxt-link :to="areaUrl">{{ area }}</nuxt-link>
      </li>
      <li v-if="prefecture">
        <nuxt-link :to="prefectureUrl">{{ prefecture }}</nuxt-link>
      </li>
      <li v-if="city">
        <nuxt-link :to="cityUrl">{{ city }}</nuxt-link>
      </li>
      <li v-if="facilityType" class="fac-type-link">
        <nuxt-link :to="facilityTypeUrl">{{ facilityType }} </nuxt-link>
      </li>
    </ul>
    <ul v-else class="label-area">
      <li v-if="area">{{ area }}</li>
      <li v-if="prefecture">{{ prefecture }}</li>
      <li v-if="city">{{ city }}</li>
      <li v-if="facilityType" class="fac-type-link">{{ facilityType }}</li>
    </ul>
  </div>
</template>

<script>
import { createUrl } from '@/utils/create-url'
import { config } from '@/utils/config'
export default {
  props: {
    area: {
      type: String,
      default: ''
    },
    prefecture: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    enableLink: {
      type: Boolean,
      default: false
    },
    facilityType: {
      type: String,
      default: ''
    }
  },
  computed: {
    areaUrl() {
      const query = { area: this.area }
      return createUrl.createSearchUrl(query)
    },
    prefectureUrl() {
      const query = { prefecture: this.prefecture }
      return createUrl.createSearchUrl(query)
    },
    cityUrl() {
      const query = { prefecture: this.prefecture, city: this.city }
      return createUrl.createSearchUrl(query)
    },
    facilityTypeUrl() {
      const code = config.facilityTypeList.find(
        (type) => type.label === this.facilityType
      ).code
      const query = { facilityType: code }
      return createUrl.createSearchUrl(query)
    }
  }
}
</script>
